import { appInject, appInjectable } from "@core/di/utils";
import { BaseService } from "@core/services/base";
import { DI_TOKENS } from "@shared/constants/di";
import { IConfigService } from "@shared/interfaces/config-service.interface";
import { IHttpClientService } from "@shared/interfaces/http-client-service.interface";
import { IRankedSeasonAnnouncementService } from "@shared/interfaces/ranked-season-announcement-service.interface";
import {
  RankedSeasonAnnouncementDto,
  UpdateRankedSeasonAnnouncementDto,
  UpdateRankedSeasonAnnouncementResult,
} from "@shared/types/ranked-season-announcement/ranked-season-announcement.dto";

@appInjectable()
export class RankedSeasonAnnouncementService
  extends BaseService
  implements IRankedSeasonAnnouncementService
{
  private configService = appInject<IConfigService>(DI_TOKENS.configService);
  private httpClient = appInject<IHttpClientService>(
    DI_TOKENS.httpClientService,
  );
  private baseURL: string;

  constructor() {
    super();
    this.baseURL = this.configService.baseUrl;
  }

  get: IRankedSeasonAnnouncementService["get"] = async () => {
    const { data } = await this.httpClient.get<{
      data: { announcement: RankedSeasonAnnouncementDto | null };
    }>("/ranked-season-announcement", {
      baseURL: this.baseURL,
    });
    return data.data.announcement;
  };

  update: IRankedSeasonAnnouncementService["update"] = async (
    dto: UpdateRankedSeasonAnnouncementDto,
  ) => {
    const { data } = await this.httpClient.patch<{
      data: UpdateRankedSeasonAnnouncementResult;
    }>("/ranked-season-announcement", dto, {
      baseURL: this.baseURL,
    });
    return data.data;
  };
}